import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Extract avatar URL from AI Twin URL
// Pattern: https://hey.speak-to.ai/{slug} → https://s3.us-east-1.amazonaws.com/cdn.speak-to.ai/avatars/{slug}
export function getAiTwinAvatarUrl(aiTwinUrl: string | null | undefined): string | undefined {
  if (!aiTwinUrl) return undefined;
  try {
    const url = new URL(aiTwinUrl);
    const slug = url.pathname.replace(/^\//, '').split('/')[0];
    if (!slug) return undefined;
    return `https://s3.us-east-1.amazonaws.com/cdn.speak-to.ai/avatars/${slug}`;
  } catch {
    return undefined;
  }
}

// Generate initials from contact name
export function getInitials(firstName: string, lastName?: string | null): string {
  const first = firstName?.[0] || '';
  const last = lastName?.[0] || '';
  return (first + last).toUpperCase() || '?';
}
